import { IconSvg } from '../../types'

export const EveningIcon: IconSvg = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" {...props}>
      <path
        d="M3.70139 11.1735H12.4286"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.70374 13.6214H10.2963"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.6667 8.16347C10.6667 6.69071 9.47279 5.4968 8.00003 5.4968C6.52727 5.4968 5.33336 6.69071 5.33336 8.16347M8.00003 2.02775L8.00003 2.167M14.0977 7.50033L13.953 7.50034M2.17534 7.50033H2.04037M4.22879 3.7291L4.12401 3.62432M11.8761 3.62432L11.7713 3.72913"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
